module.exports = __webpack_public_path__ + "static/media/editor-publish-view.6eec6500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/editor-publish-view.jpg
// module id = 1007
// module chunks = 4